import styled from 'styled-components';

export const StyledPhoneInput = styled.input`
  flex: 1;
  width: 100%;
  border: 0.5px solid var(--way-colors-borderColor);
  color: var(--way-colors-inputColor);
  padding: 12px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  background: transparent;
  min-height: 1px;
  font-style: normal;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;

  &:hover {
    border: 0.5px solid var(--way-colors-borderHoverColor);
  }

  &:focus,
  &:focus-visible {
    outline: none;
    border: 1px solid var(--way-colors-focusColor);
  }

  &[aria-invalid='true'] {
    border-color: var(--way-colors-errorColor);
  }

  &::placeholder {
    color: var(--way-colors-inputColor);
  }
`;
